<div *ngIf="numOutputs > 1" [ngClass]="{ 'out-buttons-compact': density === 'compact' }">
  <!-- Botones para 2-4 salidas -->
  <div *ngIf="numOutputs <= 4" class="d-flex justify-content-center" role="group">
    <div class="btn-group btn-group-sm" [attr.aria-label]="'outputSelection' | translate">
      <button
        *ngFor="let i of buttons; let first = first; let last = last"
        type="button"
        class="btn btn-sm btn-outline-secondary out-btn"
        [ngClass]="{
          'active': selectedOutput === i,
          'rounded-pill-left': first,
          'rounded-pill-right': last
        }"
        (click)="selectOutput(i)"
        [title]="'viewOutputSchedule' | translate:{ output: numOutputs === 4 ? ('S' + i) : i }">
        <i class="fas fa-lightbulb me-1"></i>
        <span *ngIf="numOutputs === 2 && i === 1">{{ 'output1' | translate }}</span>
        <span *ngIf="numOutputs === 2 && i === 2">{{ 'output2Hours' | translate }}</span>
        <span *ngIf="numOutputs === 4">S{{i}}</span>
      </button>
    </div>
  </div>

  <!-- Dropdown para 5+ salidas -->
  <div *ngIf="numOutputs > 4" class="d-flex justify-content-center">
    <div class="dropdown">
      <button class="btn btn-sm btn-outline-secondary dropdown-toggle output-dropdown" type="button" id="outputDropdown"
        data-bs-toggle="dropdown" aria-expanded="false">
        <i class="fas fa-lightbulb me-1"></i>
        <ng-container *ngIf="selectedOutput === 1">{{ 'output1' | translate }}</ng-container>
        <ng-container *ngIf="selectedOutput === 2">{{ 'output2Hours' | translate }}</ng-container>
        <ng-container *ngIf="selectedOutput > 2 && selectedOutput <= 4">S{{ selectedOutput }}</ng-container>
        <ng-container *ngIf="selectedOutput > 4"
          class="text-muted ms-1">{{getXeoswitchName(selectedOutput)}}</ng-container> </button>
      <ul class="dropdown-menu dropdown-menu-center" aria-labelledby="outputDropdown">
        <li *ngFor="let i of buttons">
          <a class="dropdown-item" [class.active]="selectedOutput === i" (click)="selectOutput(i)"
            href="javascript:void(0)">
            <i class="fas fa-lightbulb me-2"></i>
            <ng-container *ngIf="i === 1">{{ 'output1' | translate }}</ng-container>
            <ng-container *ngIf="i === 2">{{ 'output2Hours' | translate }}</ng-container>
            <ng-container *ngIf="i > 2 && i <= 4">S{{ i }}</ng-container>
            <ng-container *ngIf="i > 4" class="text-muted ms-1">{{getXeoswitchName(i)}}</ng-container>
          </a>
        </li>
      </ul>
    </div>
  </div>
</div>
